import React, { useState } from 'react'
import styles from "./InventoryComplianceList.scss"
import { getInventoryImagePath } from '../product-inventory/productrinventory.common.utils';
import Image from "../../common/product-image/ImageViewUpload";
// import EditInventoryBatch from '../../common/UpdateMRP/editInventoryBatch';
import InventoryBatches from '../InventoryBatches/InventoryBatches';
import { connect } from 'react-redux';


function InventoryComplianceList(props) {

  const { products, props: parentProps } = props


  const [showEdidtEnven, setShowEdidtEnven] = useState(false)
  const [SelectedProduct, setSelectedProduct] = useState()

  const showMRPCompliance = (product) => {
    setShowEdidtEnven(true)
    setSelectedProduct({ ...product, hideQuantity: true })
  }

  return (
    <div className={styles["InventoryComplianceList"]}>
      {props.allProducts.map(productlist => {
        const product = products[productlist.productId]
        const formatImageUrl = getInventoryImagePath(product?.imageUrl?.split(',')[0], product.isTemplate);

        return <div className={styles["product-row"]} onClick={() => showMRPCompliance(product)} >
          <div className={styles["product-image"]}>
            {

              <Image
                {...parentProps}
                {...product}
                showAddImageWithText
                showCheckBox={false}
                imageUrlArr={product.imageUrlArr.map(e => {
                  // delete e["actualPath"]
                  return e
                })}
                isBrandedProd={true}
                isGalleryProd={false}
                pos='bottom'
                fromListing={true}
                isTemplate={true}
                isAddImageDiv={true}
              />
            }
          </div>
          <div className={styles["product-info"]}>
            <div className={styles["product-name"]}>
              {product.productName}
            </div>
            <div className={styles["mrp_com_required"]}>
              <span className='icon-alertNew icon-pending-alert'></span>&nbsp;
              <span className={styles["mrp_com_required_text"]}>{
                (() => {
                  switch (product?.reviewStatus) {
                    case "INVENTORY_COMPLIANCE_PENDING":
                      return "Awaiting Inventory Compliance"
                    case "REJECTED":
                    case "DOCUMENT_PENDING":
                      return "MRP Compliance Required"
                    case "APPROVAL_PENDING":
                      return "MRP Compliance Approval Pending"
                    case "APPROVAL_PENDING2":
                      return "Expiry Compliance Required"

                    default:
                      if (product?.reviewStatus?.split(',').includes('REJECTED') || product?.reviewStatus?.split(',').includes('DOCUMENT_PENDING')) {
                        return "MRP Compliance Required"
                      } else {
                        return ""
                      }

                  }
                })()
              }</span>

            </div>
          </div>
        </div>

      })}


      {showEdidtEnven && SelectedProduct &&
        // <EditInventoryBatch
        //   {...Object.assign({}, parentProps, props, { productData: SelectedProduct })}
        //   showSlider={showEdidtEnven}
        //   onSliderStateChange={e => setShowEdidtEnven(e)}
        //   parentStyle={styles}
        //   fromInventoryCompliance={true}
        // />
        <InventoryBatches
          itemInfo={ SelectedProduct }
          tabKey={parentProps.tabKey}
          componentlabel="Inventory Compliance"
          onHidden={() => setShowEdidtEnven(false)}
          isListing={true}
        />
      }
    </div>
  )
}


const mapStateToProps = (state, props) => {
  return {
    session: state.session,
    deviceData: state.library.deviceData,//state.deviceData,
    isSourceJustdial: state.session.isJdSourceAndroid || state.session.isJdSourceIOS,
    isJdBusinessIOS: state.session.isJdBusinessIOS,
    isJdSourceIOS: state.session.isJdSourceIOS,
    isJdSourceAndroid: state.session.isJdSourceAndroid
  };
};

export default connect(mapStateToProps, {})(InventoryComplianceList)
